import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../AuthContext.js";
import api from "../api/axios.js";
import "./Chat.css"; // استيراد التصميم الجديد



function Chat({ receiverId }) {
  const { user } = useAuth(); // المستخدم الحالي
  const senderId = user?.id;  // ID المستخدم
  const [text, setText] = useState("");
  const [messages, setMessages] = useState([]);
  const messagesEndRef = useRef(null);
  const [conversationId, setConversationId] = useState(null);

  // إنشاء أو جلب المحادثة عند البداية
  useEffect(() => {
    const createOrFetchConversation = async () => {
      if (!senderId || !receiverId) return;

      try {
        const res = await api.post("/create-conversation", {
          user_one_id: senderId,
          user_two_id: receiverId,
        });
        setConversationId(res.data.conversation.id);
      } catch (err) {
        if (err.response && err.response.data) {
          console.log("Laravel validation errors:", err.response.data.errors);
        } else {
          console.error(err);
        }
      }
    };

    createOrFetchConversation();
  }, [senderId, receiverId]);

  // جلب الرسائل
  useEffect(() => {
    if (!conversationId) return;

    const fetchMessages = async () => {
      try {
        const res = await api.get(`/conversations/${conversationId}/messages`);
        setMessages(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchMessages();
    const interval = setInterval(fetchMessages, 3000);
    return () => clearInterval(interval);
  }, [conversationId]);

  // تمرير تلقائي لأسفل
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // إرسال رسالة
  const handleSend = async () => {
    if (!text.trim() || !conversationId) return;

    try {
      const res = await api.post("/send-message", {
        conversation_id: conversationId,
        sender_id: senderId,
        message: text,
      });
      setMessages([...messages, res.data.message]);
      setText("");
    } catch (err) {
      console.error(err);
    }
  };

  if (!user) return <p>جارٍ التحميل أو تسجيل الدخول مطلوب...</p>;

  return (
    <div className="chat-container">
      <div className="chat-header">💬 المحادثة</div>
      <div className="chat-messages">
        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`message ${msg.sender_id === senderId ? "sent" : "received"}`}
          >
            {msg.message}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <div className="chat-input">
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="اكتب رسالة..."
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
        />
        <button onClick={handleSend}>إرسال</button>
      </div>
    </div>
  );
}

export default Chat;
